var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('div',{staticClass:"container-nzidoo"},[_c('page-title',{attrs:{"title":"User Profile"}}),_c('SellerInformationComp',{attrs:{"showReviews":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }